import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'keys',
  async getComponent (nextState) {
    const {
      default: KeysContainer
    } = await import(/* webpackChunkName: "keys-container" */ './containers/KeysContainer')
      .catch(handleChunkLoadError);
    return KeysContainer;
  },
  children: [{
    path: '',
    getData ({ context: { props } }) {
      return props;
    },
    async getComponent (nextState) {
      const {
        default: Keys
      } = await import(/* webpackChunkName: "keys" */ './components/Keys')
        .catch(handleChunkLoadError);
      return Keys;
    }
  }]
});
